import { render, staticRenderFns } from "./accessArea.vue?vue&type=template&id=eb203b76&scoped=true&"
import script from "./accessArea.vue?vue&type=script&lang=js&"
export * from "./accessArea.vue?vue&type=script&lang=js&"
import style0 from "./accessArea.vue?vue&type=style&index=0&id=eb203b76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb203b76",
  null
  
)

export default component.exports